import "./EditHolidays.html";
import "./EditHolidays.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditHolidaysComponentController from "./EditHolidaysComponentController";

export default class EditHolidaysComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditHolidaysComponentController;
        this.templateUrl = "/App/Components/Partners/Details/EditHolidays/EditHolidays.html";
    }
}

module("mmManagePortal").component("irEditPartnerHolidays", new EditHolidaysComponent());
